// extracted by mini-css-extract-plugin
module.exports = {"infoBlock":"InfoBlock_infoBlock__DPZ-q","infoBlockTitle":"InfoBlock_infoBlockTitle__2QAzk","infoBlockTitleCenter":"InfoBlock_infoBlockTitleCenter__2rf87"};